import { Alert, Snackbar } from "@mui/material";
import React, { ReactNode, createContext, useContext, useState } from "react";

interface ISnackBarContext {
  openSnackbar: (message: any, isError?: any, autoHide?: boolean) => void;
}

const SnackBarContext = createContext<ISnackBarContext | undefined>(undefined);

export const useSnackBar = () => {
  const context = useContext(SnackBarContext);
  if (!context) {
    throw new Error("useSnackBar must be within a SnackBarContextProvider");
  }
  return context;
};

export const SnackBarContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, setState] = useState({
    message: "",
    isError: false,
    isOpen: false,
    autoHide: true,
  });

  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setState((prevState) => ({ ...prevState, isOpen: false }));
  };

  const openSnackbar = (message: any, isError = false, autoHide = true) => {
    setState({
      message,
      isError,
      isOpen: true,
      autoHide,
    });
  };

  return (
    <SnackBarContext.Provider value={{ openSnackbar }}>
      <Snackbar
        open={state.isOpen}
        autoHideDuration={state.autoHide ? (state.isError ? 6000 : 3000) : null}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Alert
          severity={state.isError ? "error" : "success"}
          sx={{ width: "100%" }}
          onClose={handleClose}
        >
          {state.message}
        </Alert>
      </Snackbar>
      {children}
    </SnackBarContext.Provider>
  );
};
